import { useCallback, useEffect, useRef } from 'react';

/**
 * Returns a ref callback for a <textarea> that auto-grows to fit its content.
 * Pass `value` so the height recalculates whenever the controlled value changes.
 */
export function useAutoGrow(value: string) {
    const elRef = useRef<HTMLTextAreaElement | null>(null);

    const resize = useCallback(() => {
        const el = elRef.current;
        if (!el) return;
        el.style.height = 'auto';
        el.style.height = `${el.scrollHeight}px`;
    }, []);

    // Resize whenever the value changes (covers both typing and loading saved data).
    useEffect(() => {
        resize();
    }, [value, resize]);

    const ref = useCallback((el: HTMLTextAreaElement | null) => {
        elRef.current = el;
        if (el) resize();
    }, [resize]);

    return ref;
}
